import React, { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { RouteComponentProps } from "react-router-dom";
import {
  ExperimentState,
  FlightModuleProps,
  CoreFlightsCheckout,
} from "redmond";
import { useUserContext, isCorpTenant, CDN_ASSETS } from "@capone/common";
import { useFlightsCheckoutProps } from "@capone/portal";

import config from "../../../utils/config";
import { colors as caponeColors } from "../../../utils/capone/colors";
import { colors as corpColors } from "../../../utils/capone-corporate/colors";
import App from "../../../../../../cap1-modules/flights-module/src/App";

interface IFlightsModuleProps extends RouteComponentProps {
  language: string;
  experiments?: ExperimentState;
  crossSellLoaded: boolean;
  recentlyViewedLoaded: boolean;
  annualTravelCreditLoaded: boolean;
  core?: CoreFlightsCheckout;
}

const FlightsModule = (props: IFlightsModuleProps) => {
  const { language, experiments, core, ...routerProps } = props;
  const theme = useTheme();

  const { sessionInfo, policies, logo, isRewardsDisabled } = useUserContext(
    config.TENANT
  );
  const { history } = routerProps;

  const isCorp = isCorpTenant(config.TENANT);
  const moduleProps: FlightModuleProps & { skipPortalProvider?: boolean } =
    useMemo(
      () => ({
        colors: isCorp ? corpColors : caponeColors,
        experiments,
        language,
        theme,
        baseHistory: history,
        clientAssets: {
          sessionInfo,
          logo: <img src={logo?.src} alt={logo?.alt} />,
          policies,
          isRewardsDisabled,
        },
        isAgentPortal: config.ptIsAgentPortal,
        core,
        searchImage: isCorp
          ? CDN_ASSETS.caponeCorporate.searchLoading.flights
          : CDN_ASSETS.capone.searchLoading.flights,
        skipPortalProvider: true,
      }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [isRewardsDisabled]
    );

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <App {...moduleProps} />;
};

export const LegacyFlightsBooking = (
  props: React.ComponentProps<typeof FlightsModule>
) => {
  const checkoutProps = useFlightsCheckoutProps();

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <FlightsModule {...props} core={checkoutProps} />;
};
